export const email = {
    IS_VALID_REGEX:
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
}

export const guid = {
    IS_VALID_REGEX: /^[0-9a-f]{8}(-[0-9a-f]{4}){3}-[0-9a-f]{12}$/i
}

export const phone = {
    AUS_REGEX:
        /\({0,1}((0|\+61)(\s+)?(2|4|3|7|8)){0,1}\){0,1}( |-|.){0,1}[0-9]{2}( |-|.){0,1}[0-9]{2}( |-|.){0,1}[0-9]{1}( |-|.){0,1}[0-9]{3}/
}
export const medicare = {
    MEDICARE_REGEX: /^\d{4}\s\d{5}\s\d{2}$/
}

export const character = {
    ALPHA_REGEX: /[a-zA-Z]/,
    LOWERCASE_REGEX: /[a-z]/,
    UPPERCASE_REGEX: /[A-Z]/,
    NUMERIC_REGEX: /\d/,
    SPECIAL_CHAR_REGEX: /[^a-zA-Z0-9\r\n]/
}

export const extension = {
    EXCEL_REGEX: /\.(xlsx|xls|csv)$/
}

export const colors = {
    STARTS_WITH_HASH_REGEX: /^#/g,
    STARTS_WITH_RGBA_REGEX: /^rgba/,
    CAPTURED_RGB_REGEX: /^(rgb)/,
    MATCH_HASH_ONLY_REGEX: /[#]/g,
    MATCH_HASH_REGEX: /[#()]/g,
    MATCH_RGB_REGEX: /[rgb()]/g,
    HEX_REGEX: /^#([a-f\d]{3}){1,2}$/i,
    HEX_SHORT_REGEX: /^#([a-f\d]{3})$/i,
    RGB_REGEX: /^(rgb)\([^\d]*(\d{1,3}%?,\s*){2}\d{1,3}%?\)$/i,
    RGBA_REGEX: /^(rgba)\([^\d]*(\d{1,3}%?,\s*){3}(1(\.0{0,2})?|0(\.\d{1,2})?)\)$/i,
    HEX_CODE_REGEX: /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i,
    HEX_SHORT_HAND_REGEX: /^#?([a-f\d])([a-f\d])([a-f\d])$/i
}
